import { useEffect, useState } from "react";
import useGet from "../../actprep-ui/hooks/api/useGet";
import { apiUrls } from "../../actprep-ui/utils/urls";
import { Box } from "@mui/system";
import {
  Divider,
  Grid,
  TextField,
  Typography,
  Chip,
  Button,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import useDisclosure from "../../actprep-ui/hooks/ui/useDisclosure";
import AssignProgramDialog from "../AssignProgramDialog";
import { showSuccessSnackbar } from "../../actprep-ui/utils/feedback";
import api from "../../actprep-ui/utils/api";
import { useConfirm } from "material-ui-confirm";
import ProgramAssignmentList from "../ProgramAssignmentList";

export default function TeamForm({ teamId, onSubmit }) {
  const confirm = useConfirm();
  const { data: teamData } = useGet(apiUrls.admin.teams(teamId), {
    params: {
      keep_related: true,
    },
    enabled: !!teamId,
  });
  const { data: teamToProgramData, refetch: refetchPrograms } = useGet(
    apiUrls.admin.teamToProgram(),
    {
      params: {
        search_params: {
          team_id: teamId,
        },
        keep_related: true,
      },
      enabled: !!teamId,
    }
  );

  const [title, setTitle] = useState("");
  const assignProgramDisc = useDisclosure();

  useEffect(() => {
    if (!teamData) {
      return;
    }
    const team = teamData.data;
    setTitle(team.title || "");
  }, [teamData]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const payload = {
      title,
    };
    const response = await api.put(apiUrls.admin.teams(teamId), payload);
    if (response.status == 200) {
      showSuccessSnackbar("Team Saved!");
      if (onSubmit) {
        onSubmit();
      }
    }
  };
  const handleDelete = (teamToProgramId) => {
    confirm({
      title: "Are you sure?",
      description:
        "Please confirm that you want to unassign this team to the program.",
    })
      .then(async () => {
        const response = await api.delete(
          apiUrls.admin.teamToProgram(teamToProgramId)
        );
        if (response.status == 200) {
          showSuccessSnackbar("Program Unassigned!");
          refetchPrograms();
        }
      })
      .catch(() => {});
  };

  return (
    <>
      <AssignProgramDialog
        apiUrl={apiUrls.admin.teamToProgram()}
        defaultValues={{
          team_id: teamId,
        }}
        {...assignProgramDisc.getDisclosureProps()}
        onSubmit={() => {
          assignProgramDisc.onClose();
          showSuccessSnackbar("Program Assigned!");
          refetchPrograms();
        }}
      />
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Typography variant="h5" fontWeight="bold" mb={1}>
              Edit Team
            </Typography>
            <Divider />
          </Grid>

          <Grid size={12} container>
            <Grid size={10} alignItems={"center"} display={"flex"}>
              <TextField
                label="Title"
                variant="standard"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
                fullWidth
                required
              />
            </Grid>
            <Grid size={2} alignItems={"center"} display={"flex"}>
              <Button type="submit" variant="contained" size="small">
                Save
              </Button>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Typography display="flex" alignItems="center" mb={1}>
              <span>Programs</span>
              <Chip
                label="Add"
                icon={<Add />}
                size="small"
                clickable
                sx={{ ml: 1 }}
                component={"span"}
                {...assignProgramDisc.getButtonProps()}
              />
            </Typography>
            {teamToProgramData?.data && (
              <ProgramAssignmentList
                onDelete={handleDelete}
                assignments={teamToProgramData.data}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
